<template>
  <v-dialog
    v-model="showDialog"
    max-width="500px"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    transition="dialog-bottom-transition"
    :eager="!lazy"
    scrollable
    @leave="leave()"
  >
    <template v-slot:activator="{ on }">
      <slot
        name="activator"
        v-on="on"
      />
    </template>

    <v-card>
      <v-toolbar
        v-if="$vuetify.breakpoint.xsOnly"
        dark
        color="primary"
      >
        <v-btn
          icon
          @click="cancel"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            v-if="negativeText"
            text
            color="error"
            @click="negative"
          >
            {{ negativeText }}
          </v-btn>
          <v-btn
            text
            @click="positive"
          >
            {{ positiveText }}
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-title v-if="title">
        <div>
          <div
            v-if="$vuetify.breakpoint.smAndUp"
            class="headline"
          >
            {{ title }}
          </div>
          <div v-if="subtitle">
            {{ subtitle }}
          </div>
        </div>
        <v-spacer />
        <slot name="title" />
      </v-card-title>
      <v-card-text>
        <v-container
          fluid
          grid-list-md
        >
          <v-layout
            row
            wrap
          >
            <!-- Main Content -->
            <slot />
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions v-if="!$vuetify.breakpoint.xsOnly">
        <v-btn
          v-if="negativeText"
          color="error"
          :disabled="loading"
          @click="negative()"
        >
          {{ negativeText }}
        </v-btn>

        <v-spacer />

        <v-btn
          text
          :disabled="loading"
          @click="cancel()"
        >
          {{ cancelText }}
        </v-btn>

        <v-btn
          depressed
          color="primary"
          :disabled="loading"
          :loading="loading"
          @click="positive()"
        >
          {{ positiveText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    positiveText: {
      type: String,
      default: 'OK'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    negativeText: {
      type: String,
      default: 'Delete'
    },
    show: {
      type: Boolean,
      default: undefined
    },
    lazy: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      internalShow: false
    }
  },
  computed: {
    showDialog: {
      get () {
        if (this.show !== undefined) {
          return this.show
        } else {
          return this.internalShow
        }
      },
      set (value) {
        if (this.show !== undefined) {
          if (!value) {
            this.$emit('close')
          }
        } else {
          this.internalShow = value
        }
      }
    }
  },
  mounted () {
    document.addEventListener('keyup', this.onKeyup)
  },
  destroyed () {
    document.removeEventListener('keyup', this.onKeyup)
  },
  methods: {
    positive () {
      this.$emit('positive')
    },
    cancel () {
      this.showDialog = false
      this.$emit('cancel')
    },
    negative () {
      this.$emit('negative')
    },
    onKeyup (e) {
      if (e.keyCode === 27) {
        if (this.showDialog) {
          this.cancel()
        }
      }
    }
  }
}
</script>

<style>

</style>
